import React from 'react'
import { toast } from 'react-toastify'
import renderHTML from 'react-render-html'
import moment from 'moment'
import * as Store from '../../store'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {
  faFile,
  faFilePdf,
  faFileImage,
  faFileExcel,
  faFileWord,
  faFileArchive,
  faDollarSign,
  faEuroSign,
  faPoundSign,
  faYenSign,
  faInr,
  faLiraSign,
  faRubleSign,
  faBahtSign,
  faPesoSign,
  faWonSign,
  faShekelSign,
  faManatSign,
  faTengeSign,
  faHryvniaSign,
  faCediSign,
  faNairaSign,
  faColonSign,
  faKipSign,
  // faDramSign,
  // faTugrikSign,
  faGuaraniSign,
  // faLeiSign,
  // faSomSign,
  // faAfghaniSign,
  faBirrSign,
  faDongSign,
  // faKorunaSign,
  // faForintSign,
  // faKroneSign,
  faLariSign,
  // faDirhamSign,
  // faRialSign,
} from '@fortawesome/free-solid-svg-icons'
class Utility {
  //common toast notifications fn
  static toastNotifications = (
    message,
    title,
    type,
    autoclose = true,
    companyLogo = '',
    component = <></>
  ) => {
    let errorToastId = ''
    let warningToastId = ''
    let callbackToastId = ''
    //success toast message
    if (type === 'success') {
      let _autoclose = 4000
      if (autoclose === false) {
        _autoclose = autoclose
      }
      toast.success(
        <div className='tostify-inner-box'>
          <div className='iconboxInner'>
            <div className='alert_img_box'>&nbsp;</div>
          </div>
          <div className='titleanddescriptionbox'>
            <h1>{title}</h1>
            <div className='alert_box_inner'>
              <div className='message_dec_box'>{renderHTML(message)}</div>
            </div>
          </div>
        </div>,
        {
          position: 'bottom-left',
          autoClose: _autoclose,
          transition: toast.slide,
          hideProgressBar: false,
          icon: false
        }
      )
    } else if (type === 'reminder') {
      // reminder toast notification
      let _autoclose = 4000
      if (autoclose === false) {
        _autoclose = autoclose
      }
      toast.success(
        <div className='alert_box_reminder_container'>
          <h1>{title}</h1>
          <div className='alert_box_inner'>
            <div className='alert_img_reminder_box'>&nbsp;</div>
            <div className='message_dec_box'>{renderHTML(message)}</div>
          </div>
        </div>,
        {
          position: 'bottom-left',
          autoClose: _autoclose,
          transition: toast.slide,
          hideProgressBar: false,
          closeOnClick: true
        }
      )
    } else if (type === 'info') {
      // info toast notification
      let _autoclose = 4000
      if (autoclose === false) {
        _autoclose = autoclose
      }
      toast.success(
        <div className="tostify-inner-box infoToastMsg">
          <div className="iconbox">
            <div className="alert_img_info">&nbsp;</div>
          </div>
          <div className="titleanddescriptionbox">
            <h1>{title}</h1>
            <div className="alert_box">
              <div className="message_dec">
                {message.split("\n").map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
              </div>
            </div>
          </div>

        </div>,
        {
          position: 'bottom-left',
          autoClose: _autoclose,
          transition: toast.slide,
          hideProgressBar: false
        }
      )
    } else if (type === 'error') {
      //error toast notification
      errorToastId = message
      let _autoclose = 4000000
      if (autoclose === false) {
        _autoclose = autoclose
      }
      if (!toast.isActive(errorToastId)) {
        toast.error(
          <div className='tostify-inner-box errorToastMsg'>
            <div className='titleanddescriptionbox'>
              <h1>{title}</h1>
              <div className='alert_box_inner'>
                <div className='message_dec_box'>{renderHTML(message)}</div>
              </div>
            </div>
            <div className='iconboxInner'>
              <div className='alert_img_box_error'>&nbsp;</div>
            </div>
          </div>,
          {
            position: 'bottom-left',
            autoClose: _autoclose,
            transition: toast.slide,
            hideProgressBar: true,
            toastId: errorToastId,
            closeOnClick: true
          }
        )
      }
    } else if (type === 'warning') {
      // warning toast notification
      warningToastId = message
      let _autoclose = 4000
      if (autoclose === false) {
        _autoclose = autoclose
      }
      if (!toast.isActive(warningToastId)) {
        toast.warning(
          <div className='tostify-inner-box'>
            <div className='iconboxInner'>
              <div className='alert_img_box_warning'>&nbsp;</div>
            </div>
            <div className='titleanddescriptionbox'>
              <h1>{title}</h1>
              <div className='alert_box_inner'>
                <div className='message_dec_box'>{renderHTML(message)}</div>
              </div>
            </div>
          </div>,
          {
            position: 'bottom-left',
            autoClose: _autoclose,
            transition: toast.slide,
            hideProgressBar: false,
            toastId: warningToastId,
            closeOnClick: true,
            icon: false
          }
        )
      }
    } else if (type === 'longError') {
      // long error toast notification
      errorToastId = message
      if (!toast.isActive(errorToastId)) {
        toast.error(
          <div className='warning_message_box_long_container'>
            <div className='iconboxInner'>
              <div className='alert_img_box_warning'>&nbsp;</div>
            </div>
            <h1 className='error_title_box'>{title}</h1>
            <div className='message_descriptipn_box error_title_dec_box'>
              {renderHTML(message)}
            </div>
          </div>,
          {
            position: 'bottom-left',
            autoClose: false,
            transition: toast.slide,
            hideProgressBar: true,
            toastId: errorToastId,
            closeOnClick: true
          }
        )
      }
    } else if (type === 'callback') {
      // callback type toast notification
      callbackToastId = message
      if (!toast.isActive(callbackToastId)) {
        toast(component, {
          position: toast.POSITION.TOP_LEFT,
          transition: toast.slide,
          toastId: callbackToastId,
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          closeButton: false
        })
      }
    }
  }

  //toast message dismiss fn
  static toastNotificationsDismissAll = () => {
    toast.dismiss()
  }

  //name display format
  static displayNameFormat = (first_name = '', last_name = '') => {
    let concatname = first_name + ' ' + last_name
    return concatname
  }

  //role wise permission and userwise permission
  static roleWisePermission = (userId, visitorId, roleName) => {
    let permission = false
    if (roleName == 'app_admin') {
      permission = true
    } else {
      if (userId == visitorId) {
        permission = true
      }
    }

    return permission
  }

  //custom date picker function
  static customDatePicker = () => {
    const myCustomLocale = {
      // months list by order
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],

      // week days by order
      weekDays: [
        {
          name: 'Monday',
          short: 'M'
        },
        {
          name: 'Tuesday',
          short: 'T'
        },
        {
          name: 'Wednesday',
          short: 'W'
        },
        {
          name: 'Thursday',
          short: 'T'
        },
        {
          name: 'Friday',
          short: 'F'
        },
        {
          name: 'Saturday',
          short: 'S',
          isWeekend: true
        },
        {
          name: 'Sunday', // used for accessibility
          short: 'S', // displayed at the top of days' rows
          isWeekend: true // is it a formal weekend or not?
        }
      ],

      // just play around with this number between 0 and 6
      weekStartingIndex: 0,

      // return a { year: number, month: number, day: number } object
      getToday(gregorainTodayObject) {
        return gregorainTodayObject
      },

      // return a native JavaScript date here
      toNativeDate(date) {
        return new Date(date.year, date.month - 1, date.day - 1)
      },

      // return a number for date's month length
      getMonthLength(date) {
        return new Date(date.year, date.month, 0).getDate()
      },

      // return a transformed digit to your locale
      transformDigit(digit) {
        return digit
      },

      // texts in the date picker
      nextMonth: 'Next Month',
      previousMonth: 'Previous Month',
      openMonthSelector: 'Open Month Selector',
      openYearSelector: 'Open Year Selector',
      closeMonthSelector: 'Close Month Selector',
      closeYearSelector: 'Close Year Selector',
      defaultPlaceholder: 'Select...',

      // for input range value
      from: 'from',
      to: 'to',

      // used for input value when multi dates are selected
      digitSeparator: ',',

      // if your provide -2 for example, year will be 2 digited
      yearLetterSkip: 0,

      // is your language rtl or ltr?
      isRtl: false
    }
    return myCustomLocale
  }

  //get current month first day and last day fn
  static currentMonthFirstDayLastDayFormat = () => {
    const currentDate = moment()
    const firstDayOfMonth = currentDate.clone().startOf('month')
    const lastDayOfMonth = currentDate.clone().endOf('month')
    const firstDayOfMonthString = firstDayOfMonth.format('YYYY-MM-DD')
    const lastDayOfMonthString = lastDayOfMonth.format('YYYY-MM-DD')
    let returnCurrentMonthFirstDayLastDay = {
      start_date: firstDayOfMonthString,
      end_date: lastDayOfMonthString
    }
    return returnCurrentMonthFirstDayLastDay
  }

  //get role object from event key name 
  static getRoleObjectByEventKey = (eventKey) => {
    let roleJsonData = Store.default.getState().LoginReducer.userCredentials.user_details.role_permission;
    // console.log("eventKey========",eventKey)
    // console.log("roleJsonData=========",typeof JSON.parse(roleJsonData))
    // console.log("roleJsonData=========",JSON.parse(roleJsonData))
    let foundObject = JSON.parse(roleJsonData).find(item => item.eventKey === eventKey);
    // console.log("foundObject=========", eventKey,foundObject)
    return foundObject || {};
  }

  //get role permissions object from event key and sub-event key
  static getRoleObjectBySubEventKey = (passEventKey, passVariable) => {
    let roleJsonData = Store.default.getState().LoginReducer.userCredentials
      .user_details.role_permission
    let objectsWithSubEventKey = JSON.parse(roleJsonData).filter(
      (item) => item.eventKey == passEventKey
    )
    let matchedObjects = []
    if (objectsWithSubEventKey && objectsWithSubEventKey.length > 0) {
      for (let i = 0; i < objectsWithSubEventKey.length; i++) {
        let obj = objectsWithSubEventKey[i]
        if (obj.subeventKey) {
          for (let j = 0; j < obj.subeventKey.length; j++) {
            let subEventMatch = obj.subeventKey[j]
            if (subEventMatch.eventKey === passVariable) {
              if (subEventMatch.rules !== '') {
                matchedObjects = []
                matchedObjects.push(subEventMatch)
              }
            }
          }
        }
      }
    }
    return matchedObjects
  }

  //capitalize first letter of each word
  static capitalizeFirstLetterOfEachWord(str) {
    // Split the string into words
    const words = str.split(/\s+/)
    // Capitalize the first letter of each word
    const capitalizedWords = words.map((word) => {
      if (word.length > 0) {
        return word.charAt(0).toUpperCase() + word.slice(1)
      } else {
        return word // If the word is empty, keep it as is
      }
    })
    // Join the words back into a string with spaces
    return capitalizedWords.join(' ')
  }

  // Capitalize only the first letter of a string
  static capitalizeOnlyFirstLetter = (str) => {
    if (!str || typeof str !== 'string') {
      return ''
    }
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  //get currency symbol
  static getCurrencySymbol(currencyCode) {
    function identifyCurrency(value) {
      // Regular expression to match three-letter currency codes
      const currencyCodeRegex = /^[A-Z]{3}$/

      // Check if the value matches the currency code regex
      if (currencyCodeRegex.test(value)) {
        return false
      } else {
        return true
      }
    }

    try {
      const locale = localStorage.getItem('i18nextLng') || 'en-US' // Default to 'en-US' if locale is not available
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode
      })
      const parts = formatter.formatToParts(1)
      const symbol = parts.find((part) => part.type === 'currency')?.value
      let symbolOrNot = identifyCurrency(symbol)
      if (!symbolOrNot) {
        switch (currencyCode) {
          case 'AED':
            return 'د.إ' // UAE Dirham symbol
          case 'BDT':
            return '৳' // Bangladeshi Taka symbol
          default:
            return symbol
        }
      }

      return symbol
    } catch (error) {
      return ''
    }
  }
  //get two decimal number fn
  static getTwoDecimalNumber(value) {
    let floatValue = parseFloat(value)
    if (isNaN(floatValue)) {
      floatValue = 0
    }
    return floatValue.toFixed(2)
  }

  // Format currency value with symbol
  static formatCurrencyValue(value, currencyCode) {
    // Use stored currency code or default to USD
    const code = currencyCode || localStorage.getItem('currency_code') || 'INR'
    const symbol = this.getCurrencySymbol(code)
    const formattedValue = this.getTwoDecimalNumber(value)
    return `${symbol}${formattedValue}`
  }

  // Alias for formatCurrencyValue
  static formatCurrency(value, currencyCode) {
    return this.formatCurrencyValue(value, currencyCode)
  }

  // Format amount with precision preserving up to 4-6 decimals for micro amounts
  static formatAmountPrecision(val, maxDecimals = 4) {
    const num = parseFloat(val) || 0
    if (num === 0) return '0.00'
    const absVal = Math.abs(num)
    const effMax = (absVal < 0.01) ? Math.max(maxDecimals, 6) : maxDecimals
    const rounded2 = parseFloat(num.toFixed(2))
    const roundedEff = parseFloat(num.toFixed(effMax))
    if (rounded2 === roundedEff) {
      return num.toFixed(2)
    }
    let fixedStr = num.toFixed(effMax)
    let trimmed = fixedStr.replace(/0+$/, '').replace(/\.$/, '')
    const parts = trimmed.split('.')
    if (parts.length === 1) {
      trimmed = `${parts[0]}.00`
    } else if (parts[1].length === 1) {
      trimmed = `${parts[0]}.${parts[1]}0`
    }
    return trimmed
  }

  // Format currency value with dynamic decimals (up to 4-6 decimals if needed, or default 2)
  static formatDynamicCurrencyValue(value, currencyCode, maxDecimals = 4) {
    const code = currencyCode || localStorage.getItem('currency_code') || 'INR'
    const symbol = this.getCurrencySymbol(code)
    return `${symbol}${this.formatAmountPrecision(value, maxDecimals)}`
  }

  /**
   * Get conversion factor for a selected unit of measure from UOM mappings.
   * @param {Array} uomMappings - Array of UOM mapping objects
   * @param {string|number} selectedCodeOrId - Unit code, symbol, label, or UOM id to match
   * @returns {number} Conversion factor (defaults to 1 if not found or 1)
   */
  static getUomConversionFactor(uomMappings, selectedCodeOrId) {
    if (!Array.isArray(uomMappings) || selectedCodeOrId == null || selectedCodeOrId === '') return 1
    const searchStr = String(selectedCodeOrId).trim().toLowerCase()
    const matched = uomMappings.find((u) => {
      if (!u) return false
      const code = u.unit_code ? String(u.unit_code).trim().toLowerCase() : ''
      const symbol = u.symbol ? String(u.symbol).trim().toLowerCase() : ''
      const label = u.label ? String(u.label).trim().toLowerCase() : ''
      const uomId = u.uom_id != null ? String(u.uom_id).trim() : ''
      const id = u.id != null ? String(u.id).trim() : ''
      return (
        code === searchStr ||
        symbol === searchStr ||
        label === searchStr ||
        uomId === String(selectedCodeOrId).trim() ||
        id === String(selectedCodeOrId).trim()
      )
    })
    return (matched && matched.conversion_factor != null)
      ? (parseFloat(matched.conversion_factor) || 1)
      : 1
  }

  /**
   * Calculate unit price depending on base price and selected UOM conversion factor.
   * @param {number|string} basePrice - Base unit price (per base UOM)
   * @param {number|string|object|Array} factorOrUom - Conversion factor (e.g. 0.001), UOM mapping object, or array of UOM mappings
   * @param {string} [selectedUomCode] - Selected UOM code/label (if passing array of mappings as 2nd parameter)
   * @param {number} [maxDecimals=4] - Maximum decimal places to preserve (default 4)
   * @returns {string} Formatted unit price string (e.g. "0.06", "60.00", "0.0001")
   */
  static calculateUnitPriceByUom(basePrice, factorOrUom, selectedUomCode = null, maxDecimals = 4) {
    const base = parseFloat(basePrice) || 0
    let factor = 1
    if (Array.isArray(factorOrUom) && selectedUomCode) {
      factor = this.getUomConversionFactor(factorOrUom, selectedUomCode)
    } else if (factorOrUom != null && typeof factorOrUom === 'object') {
      factor = factorOrUom.conversion_factor != null ? (parseFloat(factorOrUom.conversion_factor) || 1) : 1
    } else if (factorOrUom != null) {
      factor = parseFloat(factorOrUom) || 1
    }
    const calculatedPrice = base * factor
    return this.formatAmountPrecision(calculatedPrice, maxDecimals)
  }

  /**
   * Calculate line item total amount based on quantity, unit price, discount %, and tax %.
   * @param {number|string} quantity
   * @param {number|string} unitPrice
   * @param {number|string} [discountPercent=0]
   * @param {number|string} [taxPercent=0]
   * @param {string} [taxType='EXCLUSIVE']
   * @param {number} [maxDecimals=2]
   * @returns {string} Formatted total amount string
   */
  static calculateLineAmount(quantity, unitPrice, discountPercent = 0, taxPercent = 0, taxType = 'EXCLUSIVE', maxDecimals = 2) {
    const qty = parseFloat(quantity) || 0
    const price = parseFloat(unitPrice) || 0
    const disc = parseFloat(discountPercent) || 0
    const tax = parseFloat(taxPercent) || 0

    const subtotal = qty * price
    const discountAmount = subtotal * (disc / 100)
    const afterDiscount = subtotal - discountAmount
    const taxAmount = taxType === 'EXCLUSIVE' ? afterDiscount * (tax / 100) : 0
    const total = afterDiscount + taxAmount

    return this.formatAmountPrecision(total, maxDecimals)
  }

  // Format currency value with symbol
  static formatCurrencyValueWithLongDecimal(value, currencyCode) {
    // Use stored currency code or default to USD
    const code = currencyCode || localStorage.getItem('currency_code') || 'INR'
    const symbol = this.getCurrencySymbol(code)
    let floatValue = parseFloat(value)
    if (isNaN(floatValue)) {
      floatValue = 0
    }
    return floatValue.toFixed(4)
  }

  // Helper function to format currency without fractions
  static formatCurrencyWithoutFractions = (value, currencyCode) => {
    const code = currencyCode || localStorage.getItem('currency_code') || 'INR'
    const symbol = this.getCurrencySymbol(code)
    return `${symbol}${Math.floor(value)}`
  }


  //upi validation function
  static validateUPI(upiId) {
    // Regular expression pattern for UPI ID validation
    const upiRegex = /^[\w.-]+@[\w.-]+$/

    // Check if the provided UPI ID matches the pattern
    return upiRegex.test(upiId)
  }

  //image type file accect fn
  static acceptFileType = () => {
    let fileType = '.jpg, .jpeg, .png'
    return fileType
  }

  //check file type according to incoming file type
  static checkFileType(file, allowedTypes) {
    const allowedTypesArray = allowedTypes.split(',').map((type) => type.trim())
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        const arr = new Uint8Array(reader.result.slice(0, 4))
        const header = Array.from(arr, (byte) =>
          byte.toString(16).padStart(2, '0')
        ).join('')
        const magicNumbers = {
          jpg: 'ffd8ffe0',
          jpeg: 'ffd8ffe1',
          png: ['89504e47', '0000001c'],
          xls: ['d0cf11e0', '496e6475'], // Legacy Excel files
          xlsx: ['504b0304', '496e6475'], // Open XML Excel files (also matches ZIP files)
          pdf: '25504446',
          csv: [null, '22426f6f', '534c2e20'], // CSV files don't have a specific magic number
          doc: 'd0cf11e0', // Legacy Word files
          docx: '504b0304'
        }

        for (let type of allowedTypesArray) {
          const typeWithoutDot = type.replace('.', '')
          const magicNumber = magicNumbers[typeWithoutDot]
          if (Array.isArray(magicNumber)) {
            if (magicNumber.includes(header)) {
              resolve({ isValid: true, fileType: type })
              return
            }
          } else {
            if (header.startsWith(magicNumber)) {
              resolve({ isValid: true, fileType: type })
              return
            }
          }
        }

        // If file type doesn't match any of the allowed types
        const detectedType = file.type.split('/')[1]
        resolve({ isValid: false, fileType: detectedType })
      }

      reader.onerror = () => {
        reject('Error reading file')
      }

      // Read the file
      reader.readAsArrayBuffer(file)
    })
  }

  //return start date and end date according to incoming type
  static returnStartEndDate(type) {
    let startDate = new Date(moment().format('YYYY-MM-DD'))
    let endDate = ''
    if (type === 'day') {
      endDate = new Date(moment().format('YYYY-MM-DD'))
    }
    if (type === 'month') {
      endDate = new Date(
        moment(startDate, 'YYYY-MM-DD')
          .add(1, 'month')
          .format('YYYY-MM-DD')
      )
    }
    if (type === 'year') {
      endDate = new Date(
        moment(startDate, 'YYYY-MM-DD')
          .add(1, 'year')
          .format('YYYY-MM-DD')
      )
    }
    if (type === 'day-1') {
      startDate = new Date(
        moment(startDate)
          .subtract(1, 'day')
          .format('YYYY-MM-DD')
      )
      endDate = new Date(moment().format('YYYY-MM-DD'))
    }
    if (type === 'month-1') {
      endDate = startDate
      startDate = new Date(
        moment(startDate, 'YYYY-MM-DD')
          .subtract(1, 'month')
          .format('YYYY-MM-DD')
      )
    }
    if (type === 'year-1') {
      endDate = startDate
      startDate = new Date(
        moment(startDate, 'YYYY-MM-DD')
          .subtract(1, 'year')
          .format('YYYY-MM-DD')
      )
    }
    return { startDate: startDate, endDate: endDate }
  }

  static getFormattedDateYMD(date) {
    return moment(date).format('YYYY-MM-DD');
  }

  static getFormattedDateDMY(date) {
    return moment(date).format('DD-MM-YYYY');
  }

  //remove 0 value from given input
  static hasNonZeroValues(input) {
    const numbers = input.split(',').map(Number)
    return numbers.some((num) => num !== 0)
  }

  //get am/pm from given date time
  static get12HourFormat(dateTimeString) {
    const date = new Date(dateTimeString)
    const hours = date.getHours() % 12 || 12
    const minutes = date.getMinutes()
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM'
    const formattedDate = `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      }-${date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      }-${date.getFullYear()} at ${hours}:${minutes < 10 ? '0' : ''
      }${minutes} ${ampm}`
    return formattedDate
  }

  //get date in dd-mm-yyyy hh:mm AM/PM format
  static getDateFormat(dateTimeString) {
    if (!dateTimeString) return '-'
    const date = new Date(dateTimeString)
    if (isNaN(date.getTime())) return '-'
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
    const year = date.getFullYear()

    let hours = date.getHours()
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    hours = hours < 10 ? '0' + hours : hours

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`
  }

  // Safe time formatting that handles invalid dates and time strings
  static getSafeTimeFormat(value, defaultReturn = '-') {
    if (!value || value === '-') return defaultReturn
    try {
      // Check if it's a valid date string
      const date = new Date(value)
      if (!isNaN(date.getTime())) {
        return this.get12HourFormat(value)
      }

      // If it's not a valid date, try to extract time from the string
      if (typeof value === 'string' && value.includes(':')) {
        // Try to parse as time string (HH:MM:SS or HH:MM)
        const timeMatch = value.match(/(\d{1,2}):(\d{2})(?::\d{2})?/)
        if (timeMatch) {
          const hours = parseInt(timeMatch[1], 10)
          const minutes = parseInt(timeMatch[2], 10)
          const ampm = hours >= 12 ? 'PM' : 'AM'
          const displayHours = hours % 12 || 12
          return `${displayHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`
        }
      }
      return defaultReturn
    } catch (error) {
      console.error('Error formatting date:', value, error)
      return defaultReturn
    }
  }

  // Extract time from datetime string and convert to 12-hour format
  static extractTimeFromDateTime(dateTimeString) {
    if (!dateTimeString || dateTimeString === '-') return ''
    try {
      // First try to parse as a valid date
      const date = new Date(dateTimeString)
      if (!isNaN(date.getTime())) {
        const hours = date.getHours()
        const minutes = date.getMinutes()
        const ampm = hours >= 12 ? 'PM' : 'AM'
        const displayHours = hours % 12 || 12
        return `${displayHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`
      }

      // If not a valid date, try to extract time from string like "2025-08-30 05:00:00"
      if (typeof dateTimeString === 'string' && dateTimeString.includes(':')) {
        const timeMatch = dateTimeString.match(/(\d{1,2}):(\d{2}):(\d{2})/)
        if (timeMatch) {
          const hours = parseInt(timeMatch[1], 10)
          const minutes = parseInt(timeMatch[2], 10)
          const ampm = hours >= 12 ? 'PM' : 'AM'
          const displayHours = hours % 12 || 12
          return `${displayHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`
        }
      }
      return ''
    } catch (error) {
      console.error(
        'Error extracting time from datetime:',
        dateTimeString,
        error
      )
      return ''
    }
  }
  static timeFormat(timeString, defaultDate = '2025-06-09') {
    // If timeString is time-only, prepend default date
    const fullTimeString =
      timeString.includes('T') || timeString.includes(' ')
        ? timeString
        : `${defaultDate} ${timeString}`
    const date = new Date(fullTimeString)
    if (isNaN(date.getTime())) {
      return 'Invalid Date'
    }
    const hours = date.getHours() % 12 || 12
    const minutes = date.getMinutes()
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM'
    const formattedDate = `${hours}:${minutes < 10 ? '0' : ''
      }${minutes} ${ampm}`
    return formattedDate
  }

  //get booking date ui
  static bookingDateUi = (classNameCss, actualDate, inOutDate, type) => {
    let renderDate = actualDate
    let tooltipText = null

    if (inOutDate !== null) {
      const isDifferentDate = !moment(actualDate).isSame(inOutDate, 'day')
      tooltipText = isDifferentDate
        ? `Actual ${type} : \n ${moment(inOutDate.toString()).format(
          'DD-MM-YYYY'
        )}`
        : null
    }
    let colors = '#5f646d'
    colors = inOutDate !== null && tooltipText ? 'red' : '#5f646d'

    return (
      <div className={classNameCss}>
        {inOutDate === null ? (
          <div style={{ color: colors }}>
            {moment(renderDate.toString()).format('DD-MM-YYYY')}
          </div>
        ) : tooltipText ? (
          <OverlayTrigger
            overlay={
              <Tooltip>
                {tooltipText.split('\n').map((line, ind) => (
                  <div key={ind}>{line}</div>
                ))}
              </Tooltip>
            }
          >
            <span style={{ color: colors }}>
              {moment(renderDate.toString()).format('DD-MM-YYYY')}
            </span>
          </OverlayTrigger>
        ) : (
          <span style={{ color: colors }}>
            {moment(renderDate.toString()).format('DD-MM-YYYY')}
          </span>
        )}
      </div>
    )
  }

  //User wise permission
  static userWisePermission = (userRoleId, visitorId, userType) => {
    let permission = false
    if (userType == 'admin' || userType == 'app_admin') {
      permission = true
    } else {
      if (userRoleId == visitorId) {
        permission = false
      } else {
        permission = true
      }
    }
    return permission
  }

  static getExpiryDetails = (expiresIn) => {
    var today = new Date()
    var afterAddWithToday = new Date()
    afterAddWithToday.setSeconds(
      afterAddWithToday.getSeconds() + (expiresIn - 900)
    )
    let data = {}
    data['loggedInTime'] = today
    data['expiryTime'] = afterAddWithToday
    data['expiryInterval'] = expiresIn
    return data
  }

  /**
   * Downloads a file from a URL or Blob
   * @param {string|Blob} source - URL or Blob of the file to download
   * @param {string} filename - Name of the file to be downloaded
   * @param {Function} [onSuccess] - Callback function on successful download
   * @param {Function} [onError] - Callback function when download fails
   * @returns {Promise<void>}
   */
  static downloadFile = async (source, filename, onSuccess, onError) => {
    try {
      let blob

      // If source is a URL, fetch the file first
      if (typeof source === 'string') {
        const response = await fetch(source)
        if (!response.ok) {
          throw new Error(
            `Failed to fetch file: ${response.status} ${response.statusText}`
          )
        }
        blob = await response.blob()
      } else if (source instanceof Blob) {
        // If source is already a Blob, use it directly
        blob = source
      } else {
        throw new Error('Invalid source type. Expected URL string or Blob.')
      }

      // Create a download link
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()

      // Clean up
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)

      // Call success callback if provided
      if (typeof onSuccess === 'function') {
        onSuccess()
      }
    } catch (error) {
      console.error('Error downloading file:', error)

      // Call error callback if provided
      if (typeof onError === 'function') {
        onError(error)
      } else {
        // Fallback to showing a toast notification
        Utility.toastNotifications(
          error.message || 'Failed to download file',
          'Error',
          'error'
        )
      }

      throw error // Re-throw to allow further error handling
    }
  }
  static getCurrentStore = () => {
    console.log(Store.default.getState())
    console.log(Store.default.getState().StoreReducer)
    return Store.default.getState().StoreReducer
  }

  /**
   * Check if current store is a pharmacy
   * @param {Object} currentStore - Store object (optional, will use Redux store if not provided)
   * @returns {boolean} True if store type is PHARMACY, false otherwise
   */
  static isPharmacyStore = (currentStore = null) => {
    const store = currentStore || Store.default.getState().StoreReducer.currentStore;
    if (!store?.meta_data) return false;
    const storeTypeMeta = store.meta_data.find(
      (meta) => meta.meta_key === "store_type_val"
    );
    return storeTypeMeta?.meta_value === "PHARMACY";
  }

  /**
   * Check if current store is not a restaurant
   * @param {Object} currentStore - Store object (optional, will use Redux store if not provided)
   * @returns {boolean} True if store type is NOT RESTAURANT, false otherwise
   */
  static isNotRestaurantStore = (currentStore = null) => {
    const store = currentStore || Store.default.getState().StoreReducer.currentStore;
    // if (!store?.meta_data) return true;
    if (!store?.meta_data) return false;
    // console.log("store?.meta_data",store?.meta_data)
    if (store?.meta_data.length == 0) {
      return false;
    }
    const storeTypeMeta = store.meta_data.find(
      (meta) => meta.meta_key === "store_type_val"
    );
    // console.log("storeTypeMeta?.meta_value",storeTypeMeta?.meta_value == "RESTAURANT")
    return storeTypeMeta?.meta_value !== "RESTAURANT";
  }

  /**
   * Check if current store is a restaurant
   * @param {Object} currentStore - Store object (optional, will use Redux store if not provided)
   * @returns {boolean} True if store type is RESTAURANT, false otherwise
   */
  static isRestaurantStore = (currentStore = null) => {
    const store = currentStore || Store.default.getState().StoreReducer.currentStore;
    if (!store?.meta_data) return false;
    if (store?.meta_data.length == 0) {
      return false;
    }
    const storeTypeMeta = store.meta_data.find(
      (meta) => meta.meta_key === "store_type_val"
    );
    return storeTypeMeta?.meta_value === "RESTAURANT";
  }



  // /**
  //  * Check if current store is a restaurant
  //  * @param {Object} currentStore - Store object (optional, will use Redux store if not provided)
  //  * @returns {boolean} True if store type is RESTAURANT, false otherwise
  //  */
  // static isRestaurantStore = (currentStore = null) => {
  //   const store = currentStore || Store.default.getState().StoreReducer.currentStore;
  //   if (!store?.meta_data) return false;
  //   const storeTypeMeta = store.meta_data.find(
  //     (meta) => meta.meta_key === "store_type_val"
  //   );
  //   return storeTypeMeta?.meta_value === "RESTAURANT";
  // }

  /**
   * Get date range for a given preset
   * @param {string} preset - Date preset ('today', 'yesterday', 'this_week', 'last_week', 'this_month', 'last_month')
   * @returns {Object} Object containing start and end dates
   */
  static getDatePresetRange = (preset) => {
    const now = new Date()

    const startOfDay = new Date(now)
    startOfDay.setHours(0, 0, 0, 0)

    const endOfDay = new Date(now)
    endOfDay.setHours(23, 59, 59, 999)

    switch (preset) {
      case 'today':
        return { start_date: startOfDay, end_date: endOfDay }

      case 'yesterday':
        const yesterdayStart = new Date(startOfDay)
        yesterdayStart.setDate(yesterdayStart.getDate() - 1)

        const yesterdayEnd = new Date(yesterdayStart)
        yesterdayEnd.setHours(23, 59, 59, 999)

        return { start_date: yesterdayStart, end_date: yesterdayEnd }

      case 'this_week':
        const firstDayOfWeek = new Date(startOfDay)
        firstDayOfWeek.setDate(startOfDay.getDate() - startOfDay.getDay())

        return { start_date: firstDayOfWeek, end_date: endOfDay }

      case 'last_week':
        const lastWeekStart = new Date(startOfDay)
        lastWeekStart.setDate(startOfDay.getDate() - startOfDay.getDay() - 7)

        const lastWeekEnd = new Date(lastWeekStart)
        lastWeekEnd.setDate(lastWeekStart.getDate() + 6)
        lastWeekEnd.setHours(23, 59, 59, 999)

        return { start_date: lastWeekStart, end_date: lastWeekEnd }

      case 'this_month':
        const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
        return { start_date: firstDayOfMonth, end_date: endOfDay }

      case 'last_month':
        const lastMonthStart = new Date(
          now.getFullYear(),
          now.getMonth() - 1,
          1
        )
        const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0)
        lastMonthEnd.setHours(23, 59, 59, 999)
        return { start_date: lastMonthStart, end_date: lastMonthEnd }

      default:
        return { start_date: null, end_date: null }
    }
  }

  /**
   * Get retail pharmacy drug schedules for dropdown options
   * @returns {Array} Array of drug schedule objects with schedule, type, and description
   */
  static getDrugSchedules = () => {
    return [
      {
        schedule: "OTC",
        type: "Over-the-Counter",
        description: "Medicines that can be sold without prescription."
      },
      {
        schedule: "H",
        type: "Prescription Drugs",
        description: "Includes antibiotics, antihypertensives, and other prescription-only drugs."
      },
      {
        schedule: "H1",
        type: "Critical Antibiotics and Anti-TB Drugs",
        description: "Covers specific antibiotics, anti-tuberculosis, and anti-psychotic medicines requiring strict monitoring."
      },
      {
        schedule: "X",
        type: "Narcotic and Psychotropic Drugs",
        description: "Includes narcotics and habit-forming psychotropic substances like morphine, amphetamines, etc."
      },
      {
        schedule: "G",
        type: "Drugs Requiring Medical Supervision",
        description: "Includes hormonal preparations, corticosteroids, and other drugs requiring medical supervision."
      },
      {
        schedule: "N",
        type: "Pharmacy Premises and Equipment",
        description: "Specifies minimum standards for pharmacy area and equipment."
      },
      {
        schedule: "M",
        type: "Good Manufacturing Practices (GMP)",
        description: "Defines manufacturing standards for drugs; retailers should ensure suppliers comply with GMP."
      },
      {
        schedule: "K",
        type: "Exemptions",
        description: "Lists certain drugs and substances (like disinfectants, surgical dressings) exempt from prescription requirement."
      }
    ];
  }

  static numberToWords = (num) => {
    const belowTwenty = [
      'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
      'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];

    const tens = [
      '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
    ];

    const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

    if (num === 0) return 'Zero Only';

    let words = '';
    let i = 0;

    // Helper function to convert a number less than 1000 to words
    const helper = (n) => {
      if (n === 0) return '';
      if (n < 20) return belowTwenty[n];
      if (n < 100)
        return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + belowTwenty[n % 10] : '');
      return (
        belowTwenty[Math.floor(n / 100)] +
        ' Hundred' +
        (n % 100 !== 0 ? ' ' + helper(n % 100) : '')
      );
    };

    // Split number into whole and decimal parts
    const [wholeStr, decimalStr] = num.toString().split('.');
    let whole = parseInt(wholeStr, 10);

    // Convert the whole part
    while (whole > 0) {
      const chunk = whole % 1000;
      if (chunk !== 0) {
        words =
          helper(chunk) +
          (thousands[i] ? ' ' + thousands[i] : '') +
          (words ? ' ' + words : '');
      }
      whole = Math.floor(whole / 1000);
      i++;
    }

    words += ' Only';

    // Handle decimal (fractional) part if present
    if (decimalStr && parseInt(decimalStr, 10) !== 0) {
      // Handle two decimal digits correctly (e.g., .2 should become "Twenty", not "Two")
      const decimals = parseInt(decimalStr.padEnd(2, '0').substring(0, 2), 10);
      const decimalWords = helper(decimals);
      words = words.replace(' Only', ''); // remove Only before adding decimals
      words += ` and ${decimalWords} Cents Only`;
    }

    return words.trim();
  };



  /**
   * Get drug schedule options for dropdown (schedule code and display text)
   * @returns {Array} Array of objects with value and label for dropdown
   */
  static getDrugScheduleOptions = () => {
    const schedules = Utility.getDrugSchedules();
    return schedules.map(schedule => ({
      value: schedule.schedule,
      label: `${schedule.schedule} - ${schedule.type}`
    }));
  }

  static handlePhoneInput = (e) => {
    let value = e.target.value;

    // Remove all characters except digits and '+'
    value = value.replace(/[^\d+]/g, "");

    // If "+" appears anywhere except the first position, remove it
    if (value.indexOf('+') > 0) {
      value = value.replace(/\+/g, "");  // remove all '+' that are not first
    }

    // If multiple '+' exist at first char, keep only one
    if (value.startsWith('+')) {
      value = '+' + value.slice(1).replace(/\+/g, "");
    }

    e.target.value = value;
  };

  /**
   * Remove leading zeros from a number string or input event while preserving decimals and valid zero values.
   * Examples:
   * - "05" -> "5"
   * - "007" -> "7"
   * - "0" -> "0"
   * - "00" -> "0"
   * - "0.5" -> "0.5"
   * - "00.5" -> "0.5"
   * - "-05" -> "-5"
   * 
   * @param {string|number|object} input - String, number, or synthetic input event
   * @param {boolean} [clearZero=false] - If true, converts a standalone '0' to empty string ''
   * @returns {string} Cleaned value without unnecessary leading zeros
   */
  static removeLeadingZero = (input, clearZero = false) => {
    const isEvent = input && input.target && typeof input.target.value !== 'undefined';
    const val = isEvent ? input.target.value : input;

    if (val === null || val === undefined) {
      return '';
    }

    let str = String(val).trim();
    if (str === '') {
      if (isEvent) input.target.value = '';
      return '';
    }

    // If clearZero is requested and value is already 0, clear it
    if (clearZero && (str === '0' || str === '0.00' || str === '0.0')) {
      if (isEvent) input.target.value = '';
      return '';
    }

    // Check for negative sign
    const isNegative = str.startsWith('-');
    let cleanStr = isNegative ? str.slice(1) : str;

    // Handle numbers starting with multiple zeros before a decimal point (e.g., "00.5" -> "0.5")
    if (/^0+\./.test(cleanStr)) {
      cleanStr = cleanStr.replace(/^0+/, '0');
    } else {
      // Remove leading zeros before any other digit (e.g., "005" -> "5", "00" -> "0")
      cleanStr = cleanStr.replace(/^0+(?=\d)/, '');
    }

    if (clearZero && (cleanStr === '0' || cleanStr === '')) {
      if (isEvent) input.target.value = '';
      return '';
    }

    // Normalize negative zero or empty string
    let result = (isNegative && cleanStr !== '0' && cleanStr !== '' ? '-' : '') + cleanStr;

    if (isEvent) {
      input.target.value = result;
    }

    return result;
  };

  // Alias for plural naming convention
  static removeLeadingZeros = (input, clearZero = false) => Utility.removeLeadingZero(input, clearZero);

  //===== added action permission =====//
  static hasActionPermission = (moduleKey, subModuleKey, actionKey) => {
    try {
      // const moduleObject = Utility.getRoleObjectByEventKey(moduleKey);
      const moduleObject = this.getRoleObjectByEventKey(moduleKey);

      if (!moduleObject || !moduleObject.subeventKey) {
        return false;
      }

      const subModule = moduleObject.subeventKey.find(
        item => item.eventKey === subModuleKey
      );

      // console.log("subModule===========", subModule);

      if (!subModule) {
        return false;
      }

      // Check if actions object exists and has the specific action
      if (subModule.actions && typeof subModule.actions === 'object') {
        return subModule.actions[actionKey] === true;
      }
      // else {
      //   const updated = {
      //     ...subModule,
      //     actions: {
      //       ...subModule.actions,
      //       [actionKey]: true
      //     }
      //   };
      //   return updated.actions[actionKey] === true;
      // }

      // Fallback to legacy CRUD check if actions not defined
      // This maintains backward compatibility
      if (actionKey === 'view' || actionKey === 'export') {
        return subModule.read === true || subModule.crud === true;
      }
      if (actionKey === 'create' || actionKey === 'edit' || actionKey === 'delete') {
        return subModule.write === true || subModule.crud === true;
      }

      return false;
    } catch (error) {
      console.error('Error checking action permission:', error);
      return false;
    }
  }

  static hasMultipleActionPermissions = (moduleKey, subModuleKey, actionKeys, userType) => {
    const permissions = {};

    // Check if userType is array or string, and if admin is included
    const isAdmin = Array.isArray(userType)
      ? userType.includes('admin') || userType.includes('app_admin')
      : userType === 'admin' || userType === 'app_admin';

    if (isAdmin) {
      // For admin users, grant all permissions
      actionKeys.forEach(actionKey => {
        permissions[actionKey] = true;
      });
    } else {
      actionKeys.forEach(actionKey => {
        permissions[actionKey] = this.hasActionPermission(moduleKey, subModuleKey, actionKey);
      });
    }
    return permissions;
  }

  /**
   * Check if user subscription is expired
   * @param {Object} userCredentials - User credentials object
   * @returns {boolean} - Returns true if subscription is expired or invalid, false if active
   */
  static isSubscriptionExpired = (userCredentials) => {

    // Check if user Type is app_admin
    if (userCredentials.user_details.user_type === "app_admin") {
      return false; // Admin users are always active
    }

    // Check if userCredentials exists
    if (!userCredentials) {
      return true; // Consider expired if no credentials
    }

    // Check if user_details exists
    if (!userCredentials.user_details) {
      return true; // Consider expired if no user details
    }

    // Check if is_subscribed property exists and is false
    if (userCredentials.user_details.is_subscribed === false) {
      return true; // Subscription is explicitly expired
    }

    // If is_subscribed is true or undefined, consider it active
    return false;
  };

  /**
   * Get subscription status message
   * @param {Object} userCredentials - User credentials object
   * @returns {string} - Returns appropriate message based on subscription status
   */
  static getSubscriptionStatusMessage = (userCredentials) => {
    if (this.isSubscriptionExpired(userCredentials)) {
      return "You don’t have an active subscription. Please contact support for assistance.";
    }
    return "";
  };

  static isMainOrProcurementHubStore = (currentStore) => {
    return (currentStore?.store_type === 'MAIN' || currentStore?.is_procurement_hub);
  }

  static isPmsIntegrationEnabled = (store) => {
    if (!store) return false;
    if (
      store.pms_integration_enabled === 1 ||
      store.pms_integration_enabled === true ||
      String(store.pms_integration_enabled) === '1' ||
      String(store.pms_integration_enabled).toLowerCase() === 'true'
    ) {
      return true;
    }
    if (Array.isArray(store.meta_data)) {
      const meta = store.meta_data.find((m) => m.meta_key === 'pms_integration_enabled');
      if (
        meta &&
        (meta.meta_value === 1 ||
          meta.meta_value === true ||
          String(meta.meta_value) === '1' ||
          String(meta.meta_value).toLowerCase() === 'true')
      ) {
        return true;
      }
    }
    return false;
  };

  static isChkBusinessDay = (currentStore) => {
    // Any operational unit may run a business day. Selling stores get the full
    // sales audit; procurement hubs and non-selling cost centers get an
    // inventory-scoped close (stock transfers, wastage, discrepancies). MAIN
    // stores are org-level and never close a day.
    return ['BRANCH', 'COST_CENTER'].includes(currentStore?.store_type);
  }

  static getStatusDataBadge = (status_data) => {
    const color = status_data?.color || '#637381'
    return (
      <span style={{ color, fontWeight: 500, backgroundColor: `${color}26`, padding: '2px 8px 4px 8px', borderRadius: '4px', fontSize: 12 }}>
        {status_data?.label}
      </span>
    )
  }

  static chkOrgStoreCentralHub = (currentStore, orgMetaStoreRelation) => {
    return currentStore?.store_type === 'BRANCH' && currentStore?.is_procurement_hub
    //orgMetaStoreRelation?.allow_main_store;
  }

  static chkOrgStoreCentralHubOrBranchProcumentHub = (currentStore) => {
    return (currentStore?.store_type === 'BRANCH' || currentStore?.store_type === 'MAIN') && currentStore?.is_procurement_hub;
  }

  // Format currency value with symbol
  static formatCurrencyValueWithAbs(value, currencyCode) {
    // Use stored currency code or default to USD
    const code = currencyCode || localStorage.getItem('currency_code') || 'INR'
    const symbol = this.getCurrencySymbol(code)
    const absValue = Math.abs(parseFloat(value)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return `${symbol}${absValue}`
  }

  /**
   * Get file icon based on file extension
   * @param {string} fileName - Name of the file
   * @returns {Object} FontAwesome icon object
   */
  static getFileIcon = (fileName) => {
    if (!fileName) return faFile
    const extension = fileName.split('.').pop().toLowerCase()
    switch (extension) {
      case 'pdf':
        return faFilePdf
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'bmp':
      case 'svg':
        return faFileImage
      case 'xls':
      case 'xlsx':
      case 'csv':
        return faFileExcel
      case 'doc':
      case 'docx':
        return faFileWord
      case 'zip':
      case 'rar':
      case '7z':
      case 'tar':
      case 'gz':
        return faFileArchive
      default:
        return faFile
    }
  }

  // Get currency icon name for FontAwesome
  static getCurrencyIconName(currencyCode) {
    const code = currencyCode || localStorage.getItem('currency_code') || 'INR'
    const iconMap = {
      'USD': 'faDollarSign',
      'EUR': 'faEuroSign',
      'GBP': 'faPoundSign',
      'JPY': 'faYenSign',
      'CNY': 'faYenSign',
      'INR': 'faInr',
      'NPR': 'faDollarSign',
      'BDT': 'faDollarSign',
      'LKR': 'faDollarSign',
      'PKR': 'faDollarSign',
      // 'AFN': 'faAfghaniSign',
      'MVR': 'faDollarSign',
      'BTN': 'faDollarSign',
      'TRY': 'faLiraSign',
      'RUB': 'faRubleSign',
      'AUD': 'faDollarSign',
      'CAD': 'faDollarSign',
      'SGD': 'faDollarSign',
      'HKD': 'faDollarSign',
      'NZD': 'faDollarSign',
      'CHF': 'faDollarSign',
      'MYR': 'faDollarSign',
      'THB': 'faBahtSign',
      'VND': 'faDongSign',
      'IDR': 'faDollarSign',
      'PHP': 'faPesoSign',
      'KRW': 'faWonSign',
      // 'SAR': 'faRialSign',
      // 'AED': 'faDirhamSign',
      // 'QAR': 'faRialSign',
      'KWD': 'faDollarSign',
      'BHD': 'faDollarSign',
      'OMR': 'faDollarSign',
      'JOD': 'faDollarSign',
      'EGP': 'faDollarSign',
      'ILS': 'faShekelSign',
      'AZN': 'faManatSign',
      'KZT': 'faTengeSign',
      'UAH': 'faHryvniaSign',
      'GHS': 'faCediSign',
      'NGN': 'faNairaSign',
      'CRC': 'faColonSign',
      'LAK': 'faKipSign',
      // 'AMD': 'faDramSign',
      // 'MNT': 'faTugrikSign',
      'PYG': 'faGuaraniSign',
      // 'RON': 'faLeiSign',
      // 'UZS': 'faSomSign',
      // 'KGS': 'faSomSign',
      // 'ETB': 'faBirrSign',
      // 'CZK': 'faKorunaSign',
      // 'HUF': 'faForintSign',
      // 'DKK': 'faKroneSign',
      // 'NOK': 'faKroneSign',
      // 'SEK': 'faKroneSign',
      'GEL': 'faLariSign',
      'ZAR': 'faDollarSign',
      'KES': 'faDollarSign',
      'UGX': 'faDollarSign',
      'TZS': 'faDollarSign',
      'XOF': 'faDollarSign',
      'XAF': 'faDollarSign',
      'CDF': 'faDollarSign',
      'BWP': 'faDollarSign',
      'NAD': 'faDollarSign',
      'SZL': 'faDollarSign',
      'LSL': 'faDollarSign',
      'ZMW': 'faDollarSign',
      'MWK': 'faDollarSign',
      'AOA': 'faDollarSign',
      'MZN': 'faDollarSign',
      'BRL': 'faDollarSign',
      'ARS': 'faDollarSign',
      'CLP': 'faDollarSign',
      'COP': 'faDollarSign',
      'PEN': 'faDollarSign',
      'BOB': 'faDollarSign',
      'UYU': 'faDollarSign',
      'MXN': 'faDollarSign',
      'GTQ': 'faDollarSign',
      'HNL': 'faDollarSign',
      'NIO': 'faDollarSign',
      'PAB': 'faDollarSign',
      'DOP': 'faDollarSign',
      'JMD': 'faDollarSign',
      'TTD': 'faDollarSign',
      'BBD': 'faDollarSign',
      'XCD': 'faDollarSign',
      'BZD': 'faDollarSign',
      'GYD': 'faDollarSign',
      'SRD': 'faDollarSign',
      'AWG': 'faDollarSign',
      'CUP': 'faDollarSign',
      'HTG': 'faDollarSign',
      'KYD': 'faDollarSign',
      'BMD': 'faDollarSign',
    }
    return iconMap[code] || 'faDollarSign'
  }

  // Get currency icon object for FontAwesome
  static getCurrencyIcon(currencyCode) {
    const iconName = this.getCurrencyIconName(currencyCode)
    const iconMap = {
      'faDollarSign': faDollarSign,
      'faEuroSign': faEuroSign,
      'faPoundSign': faPoundSign,
      'faYenSign': faYenSign,
      'faInr': faInr,
      'faLiraSign': faLiraSign,
      'faRubleSign': faRubleSign,
      'faBahtSign': faBahtSign,
      'faPesoSign': faPesoSign,
      'faWonSign': faWonSign,
      'faShekelSign': faShekelSign,
      'faManatSign': faManatSign,
      'faTengeSign': faTengeSign,
      'faHryvniaSign': faHryvniaSign,
      'faCediSign': faCediSign,
      'faNairaSign': faNairaSign,
      'faColonSign': faColonSign,
      'faKipSign': faKipSign,
      // 'faDramSign': faDramSign,
      // 'faTugrikSign': faTugrikSign,
      'faGuaraniSign': faGuaraniSign,
      // 'faLeiSign': faLeiSign,
      // 'faSomSign': faSomSign,
      // 'faAfghaniSign': faAfghaniSign,
      // 'faBirrSign': faBirrSign,
      'faDongSign': faDongSign,
      // 'faKorunaSign': faKorunaSign,
      // 'faForintSign': faForintSign,
      // 'faKroneSign': faKroneSign,
      'faLariSign': faLariSign,
      // 'faDirhamSign': faDirhamSign,
      // 'faRialSign': faRialSign,
    }
    return iconMap[iconName] || iconMap['faDollarSign']
  }

  static getPaymentStatusBadgeVariant = (paymentStatusData) => {
    const value = String(paymentStatusData?.value ?? '');
    const label = (paymentStatusData?.label || '').toLowerCase();

    switch (value) {
      case '0': return 'warning';
      case '1': return 'success';
      case '2': return 'danger';
      case '3': return 'info';
      case '4': return 'info';
      default: break;
    }

    if (label.includes('pending')) return 'warning';
    if (label.includes('failed')) return 'danger';
    if (label.includes('refund')) return 'info';
    if (label.includes('partially')) return 'info';
    if (label.includes('success') || label === 'paid') return 'success';

    return 'secondary';
  };

  /**
   * Maps a chosen payment method (Cash, Card, UPI, Online Gateway, Bank Transfer,
   * Bill Posting/Folio) to its corresponding postable liquid/tender Business
   * Account (1110, 1160, 1170, 1180, 1150, 1230).
   * @param {Object} method - Payment method object (payment_constant/payment_type/label/is_online_gateway)
   * @param {Array} accounts - Business accounts list (uses account_code, label, name)
   * @returns {Object|null} Matching account or null
   */
  static findMatchingBusinessAccount = (method, accounts) => {
    if (!method || !accounts || !accounts.length) return null;

    const constant = String(method.payment_constant || method.payment_type || '').toUpperCase();
    const label = String(method.label || method.payment_method_name || '').toLowerCase();
    const isOnline = Boolean(method.is_online_gateway);

    const matchAccount = (targetCode, keywords) => {
      return (
        accounts.find(a => String(a.account_code || '') === targetCode) ||
        accounts.find(a => {
          const accLabel = String(a.label || '').toLowerCase();
          return accLabel.includes(targetCode) || keywords.some(kw => accLabel.includes(kw));
        }) ||
        null
      );
    };

    // 1. Online Payment Gateway (Razorpay, Paytm PG, Web checkout) -> 1180
    if (
      isOnline ||
      constant === 'PAYMENT_GATEWAY' ||
      constant === 'ONLINE' ||
      constant === 'RAZORPAY' ||
      label.includes('gateway') ||
      label.includes('online') ||
      label.includes('razorpay')
    ) {
      const acc = matchAccount('1180', ['gateway', 'razorpay']);
      if (acc) return acc;
    }

    // 2. UPI / QR / Wallet -> 1170
    if (
      constant === 'UPI' ||
      constant === 'QR' ||
      constant === 'WALLET' ||
      label.includes('upi') ||
      label.includes('qr') ||
      label.includes('gpay') ||
      label.includes('phonepe') ||
      label.includes('paytm')
    ) {
      const acc = matchAccount('1170', ['upi', 'qr', 'dynamic qr']);
      if (acc) return acc;
    }

    // 3. Card (EDC / Swiping Machines) -> 1160
    if (
      constant === 'CARD' ||
      constant === 'CREDIT_CARD' ||
      constant === 'DEBIT_CARD' ||
      constant === 'EDC' ||
      label.includes('card') ||
      label.includes('edc') ||
      label.includes('swipe') ||
      label.includes('machine')
    ) {
      const acc = matchAccount('1160', ['card clearing', 'edc', 'swiping']);
      if (acc) return acc;
    }

    // 4. Bank Transfer / NEFT / RTGS / Cheque -> 1150
    if (
      constant === 'BANK_TRANSFER' ||
      constant === 'BANK' ||
      constant === 'NEFT' ||
      constant === 'RTGS' ||
      constant === 'CHEQUE' ||
      label.includes('bank') ||
      label.includes('neft') ||
      label.includes('rtgs') ||
      label.includes('cheque')
    ) {
      const acc = matchAccount('1150', ['main operating bank', 'bank account']);
      if (acc) return acc;
    }

    // 5. Cash / Till Floats -> 1110
    if (constant === 'CASH' || label.includes('cash')) {
      const acc = matchAccount('1110', ['cash in register', 'till float', 'till']);
      if (acc) return acc;
    }

    // 6. Room / Bill Posting / Folio / PMS / City Ledger -> 1230
    if (
      constant === 'BILL POSTING' ||
      constant === 'ROOM' ||
      constant === 'ROOM_POSTING' ||
      constant === 'FOLIO' ||
      constant === 'PMS' ||
      constant === 'CITY_LEDGER' ||
      label.includes('room') ||
      label.includes('bill posting') ||
      label.includes('folio') ||
      label.includes('pms')
    ) {
      const acc = matchAccount('1230', ['guest folio', 'folio', 'city ledger', 'pms', 'receivable']);
      if (acc) return acc;
    }

    return null;
  };

}
export default Utility
